import React from 'react';
import { st } from '../constants.js';
import { FI, Chips, SingleChip } from '../components/FormPrimitives.js';
import { SectionHeader, Sub } from '../components/SectionLayout.js';

const RiskComplications = ({ data, upd, updA }) => (
  <div style={{ animation: 'fadeIn 0.3s' }}>
    <div style={st.card}>
      <SectionHeader icon="⚠️" title="Risk Factors & Complications" subtitle="What bad things might happen if we DON'T intervene?" color="#dc2626" />

      {[
        {
          key: 'atelectasis', label: '🫁 Atelectasis Risk', riskKey: 'atelectasisRisk', factKey: 'atelectasisFactors',
          factors: ['Shallow breathing', 'Post-operative splinting', 'Pain limiting deep breathing', 'Sedation / reduced consciousness', 'Immobility', 'Poor cough effort', 'Excessive secretions', 'Prolonged supine positioning'],
          treat: ['Deep breathing exercises', 'Incentive spirometry', 'Early mobilisation', 'Positioning (upright / side-lying)', 'Pain management coordination'],
        },
        {
          key: 'pneumonia', label: '🦠 Pneumonia / Aspiration Risk', riskKey: 'pneumoniaRisk', factKey: 'pneumoniaFactors',
          factors: ['Aspiration risk (dysphagia / wet voice)', 'Secretion retention', 'Immobility', 'Reduced cough effectiveness', 'Oral hygiene poor', 'NG tube / PEG fed', 'Supine positioning'],
          treat: ['Secretion clearance techniques', 'Positioning (semi-recumbent ≥30°)', 'Oral care coordination', 'Aspiration precautions', 'Assisted cough if needed'],
        },
        {
          key: 'dvt', label: '🩸 DVT / PE Risk', riskKey: 'dvtRisk', factKey: 'dvtFactors',
          factors: ['Immobility >24hrs', 'Post-surgery (esp. orthopaedic/pelvic)', 'Heart failure', 'Malignancy', 'Previous DVT / PE', 'Dehydration', 'IV access limb', 'Pregnancy / post-partum'],
          treat: ['Early ambulation', 'Ankle pumps / calf exercises', 'Progressive walking program', 'Compression (if ordered)', 'Patient education on warning signs'],
        },
        {
          key: 'deconditioning', label: '💪 Deconditioning Risk', riskKey: 'deconditioningRisk', factKey: 'deconditioningFactors',
          factors: ['Prolonged bed rest (>48hrs)', 'ICU admission', 'Sedation / ventilation', 'Pre-morbid low activity level', 'Severe illness', 'Malnutrition', 'Prolonged O₂ dependence'],
          treat: ['Daily progressive mobility', 'Sitting out of bed (even if short)', 'Active limb exercises in bed', 'Upright positioning', 'Goal-directed mobility plan'],
        },
        {
          key: 'fall', label: '⚡ Fall Risk', riskKey: 'fallRisk', factKey: 'fallFactors',
          factors: ['Generalised weakness', 'O₂ desaturation with standing', 'Dizziness / postural hypotension', 'Medication side effects (diuretics, sedatives)', 'Environmental hazards (drips, O₂ tubing)', 'Cognitive impairment', 'Visual impairment'],
          treat: ['Supervised mobilisation', 'Transfer training', 'Walking aid prescription', 'Environmental safety assessment', 'Footwear review'],
        },
      ].map(({ key, label, riskKey, factKey, factors, treat }) => (
        <Sub key={key} title={label} can={treat}>
          <div style={st.grid3}>
            <SingleChip label="Risk Level" value={data[riskKey]} onChange={v => upd(riskKey, v)} options={['Low', 'Medium', 'High', 'Very High']} />
          </div>
          <Chips label="Contributing Factors" value={data[factKey]} onChange={v => updA(factKey, v)} options={factors} />
        </Sub>
      ))}

      <Sub title="📝 Risk Summary Notes">
        <FI label="Overall Risk Assessment & Priority Interventions" type="textarea" value={data.riskNotes} onChange={e => upd('riskNotes', e.target.value)} placeholder="e.g. Post-op day 1 with pain limiting breathing — HIGH priority for atelectasis. Begin incentive spirometry and position changes every 2 hours. Pain score 7/10 — coordinate with nursing for pre-PT analgesia." />
      </Sub>
    </div>
  </div>
);

export default RiskComplications;
